
export function initTextdynamic() {

  delayedToggleMultiline();
}



function toggleMultiline() {
  const selectors = [".lh-1-br", ".lh-xs-br", ".lh-xxs-br"];
  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      if (el.offsetParent === null) return; 
      const height = el.offsetHeight;
      const lineHeight = parseFloat(getComputedStyle(el).lineHeight);
      const tolerance = 5;
      el.classList.toggle("multiline", height > lineHeight + tolerance);
    });
  });
}
export function delayedToggleMultiline() {
  setTimeout(() => requestAnimationFrame(toggleMultiline), 50);
}
